<template lang="pug">
.sv-select(
    v-click-outside="() => toggleList(false)"
    :class="colorClass"
    tabindex="0"
)
    //- Текущий выбранный элемент
    .sv-select__current(
        @click="toggleList(!isOpen)"
    )
        .sv-select__current-text
            | {{ valueText }}

        .sv-select__current-icon
            SvIcon(
                icon="arrow-down"
                :width="16"
                :height="16"
            )

    .sv-select__list(
        v-show="isOpen"
    )
        .sv-select-search(
          v-if="withSearch"
        )
          SvInput(
            v-model="search"
            color="graylight"
            placeholder="Поиск элемента"
            :withIcon="true"
            :initAutofocus="isOpen"
            @enter="enter"
          )

        .sv-select__list-item(
            v-for="item in searchingItems"
            :class="{ 'sv-select__list-item--current': isDisabled(item) || isCurrent(item) }"
            :key="item[itemId]"
            @click="targetElement(item)"
        )
            | {{ item[itemName] }}
</template>

<script>
import vClickOutside from 'v-click-outside';
import SvInput from '@/components/uikit/SvInput.vue';
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'SvSelect',

  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    SvIcon,
    SvInput,
  },

  data() {
    return {
      isOpen: false,
      search: '',
    };
  },

  props: {
    value: {
      type: [Number, String, Object],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    withSearch: {
      type: Boolean,
      default: false,
    },
    disabledValues: {
      type: Array,
      default: () => [],
    },
    itemId: {
      type: String,
      default: 'id',
    },
    itemName: {
      type: String,
      default: 'name',
    },
    placeholder: {
      type: String,
      default: 'Выберете из списка',
    },
    view: {
      type: String,
      default: 'gray',
    },
  },

  computed: {
    searchingItems() {
      if (!this.withSearch) return this.items;
      return this.items.filter(el => el.name.toLowerCase().includes(this.search.toLowerCase()));
    },
    valueText() {
      if (this.value === null) {
        return this.placeholder;
      }
      return this.items.find(v => v[this.itemId] === this.value)[this.itemName];
    },

    colorClass() {
      return {
        [`sv-select--${this.view}`]: this.view,
        'sv-select--no-value': this.value === null,
      };
    },
  },

  methods: {

    isCurrent(item) {
      return item[this.itemId] === this.value;
    },

    toggleList(val) {
      this.isOpen = val;
      if (!val && this.search) {
        this.search = '';
      }
    },

    isDisabled(value) {
      return this.disabledValues.find(v => v[this.itemId] === value[this.itemId]);
    },

    targetElement(el) {
      this.toggleList(false);
      if (this.isDisabled(el)) {
        return;
      }
      this.$emit('input', el[this.itemId]);
    },

    enter(val) {
      if (val && this.search.length && this.searchingItems.length && !this.isDisabled(this.searchingItems[0]) && this.searchingItems[0].name) {
        this.search = this.searchingItems[0].name;
        this.targetElement(this.searchingItems[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-select-search {
    position: sticky;
    width: 100%;
    top: 0;
}
.sv-select {
    position: relative;
    height: 40px;
    display: flex;
    border-radius: 5px;
    width: 100%;

    &:focus {
        outline: 1px auto #A7ABB7;
    }

    &--gray {
        background-color: #F3F3F6;

        &.sv-select--no-value {
            .sv-select__current {
                color: #A7ABB7;
            }
        }
    }

    &--white {
        background-color: #F3F3F6;

        &.sv-select--no-value {
            .sv-select__current {
                color: #ADB2C0;
            }
        }
    }

    &__current {
        cursor: pointer;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
    }

    &__list {
        width: 100%;
        position: absolute;
        top: 40px;
        background-color: #fff;
        box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
        border-radius: 5px;
        max-height: 238px;
        overflow-y: auto;
        z-index: 1;

        & .sv-select__list-item--current {
            color: #ADB2C0;
        }
    }

    &__list-item {
        height: 34px;
        width: 100%;
        padding: 0 20px;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
            background-color: #EEF4FA;
        }
    }
}
</style>
